import styled from "styled-components";
import { hexToRgba } from "../../../../themes/hex-to-rgba";

export const VideoTileStaticImageOverlayDefaultBox = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0px;
    right: 0;
    background-color: ${props => hexToRgba(props.theme.colors.bodyBackground, 0.85)};;
`;
